import supabase from '../supabaseClient';

// Use relative proxy by default; override with REACT_APP_STRIPE_SERVER_URL if needed
const API_BASE = process.env.REACT_APP_STRIPE_SERVER_URL || '/payments';

/**
 * Creates a Stripe Checkout Session for the currently authenticated user.
 *
 * IMPORTANT SECURITY CHANGE:
 * - We DO NOT send email/user_id from the browser.
 * - We DO send the Supabase access token via Authorization header.
 * - The backend must verify the token and derive user identity from it.
 */
export async function createCheckoutSession(plan) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;

  const resp = await fetch(`${API_BASE}/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ plan }),
  });

  if (!resp.ok) {
    const msg = await resp.text().catch(() => 'Checkout session failed');
    throw new Error(msg || 'Checkout session failed');
  }
  return resp.json(); // { url }
}

export async function startPlanCheckoutOrLogin(plan, user, navigate) {
  if (!user) {
    navigate('/login');
    return;
  }

  const { url } = await createCheckoutSession(plan);
  window.location.href = url;
}
